import { immerable } from "immer";
import GeometryRepresentation from "./geometry-representation.ts";

class Measure {
    [immerable] = true;

    measureId: string;

    measureTypeId: string;

    name: string;

    geometryRepresentations: GeometryRepresentation[] = [];

    dataInformations: Record<string, unknown> | undefined = undefined;

    constructor(measureTypeId: string, name: string, measureId: string, dataInformations?: Record<string, unknown>) {
        this.measureId = measureId;
        this.measureTypeId = measureTypeId;
        this.name = name;
        this.dataInformations = dataInformations;
    }

    setGeometryRepresentations(geometryRepresentations: GeometryRepresentation[]) {
        this.geometryRepresentations = geometryRepresentations;
    }

    addGeometryRepresentation(geometryRepresentation: GeometryRepresentation) {
        this.geometryRepresentations.push(geometryRepresentation);
    }

    removeGeometryRepresentation(geometryRepresentationId: string) {
        this.geometryRepresentations = this.geometryRepresentations.filter(gr => gr.geometryRepresentationId !== geometryRepresentationId);
    }

    setMeasureTypeId(measureTypeId: string) {
        this.measureTypeId = measureTypeId;
    }

    setDataInformations(dataInformations: Record<string, unknown> | undefined) {
        this.dataInformations = dataInformations;
    }

    public editMeasure(newMeasure: Measure): void {
        this.name = newMeasure.name;
        this.measureTypeId = newMeasure.measureTypeId;
        this.geometryRepresentations = newMeasure.geometryRepresentations;
        this.dataInformations = newMeasure.dataInformations;
    }

    clone(): Measure {
        const cloned = new Measure(this.measureTypeId, this.name, this.measureId, this.dataInformations);
        cloned.geometryRepresentations = this.geometryRepresentations.map(gr => ({ ...gr }));
        return cloned;
    }
}

export default Measure;